import groupsListCtrl from './list/GroupsListController';
import groupsListTemplate from './list/groups.list.html';
import groupCreateCtrl from './create/GroupCreateController';
import groupContainerTemplate from './group/groups.group.container.html';
import groupOverviewTemplate from './group/groups.group.overview.html';
import groupContainerCtrl from './group/GroupContainerController';
import groupCtrl from './group/GroupOverviewController';
import groupTaskTriggersCtrl from './task-triggers/GroupTaskTriggersController';
import groupTaskTriggerCtrl from './task-triggers/GroupTaskTriggerController';
import groupTaskTriggersTemplate from './task-triggers/groups.group.task-triggers.html';
import groupTaskTriggerTemplate from './task-triggers/groups.group.task-trigger-form.html';
import taskTrigger from './task-triggers/taskTrigger';
import groupNotificationsCtrl from '../notifications/NotificationsListController';
import groupNotificationsTemplate from '../notifications/notification.editor.html';
import groupNotificationsListTemplate from '../notifications/notifications.list.html';
import groupManageCtrl from './manage/GroupManageController';
import groupManageTemplate from './manage/groups.group.manage.html';
import groupCreateTemplate from './create/group.create.html';

const module = angular.module('websked.groups', []);

const toLoad = [
  groupsListCtrl,
  groupCreateCtrl,
  groupContainerCtrl,
  groupCtrl,
  groupTaskTriggersCtrl,
  groupTaskTriggerCtrl,
  taskTrigger,
  groupNotificationsCtrl,
  groupManageCtrl
];

toLoad.forEach(fn => fn(module));

function routes($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('groups', {
      abstract: true,
      url: '/groups',
      template: '<div ui-view></div>',
      resolve: {
        websites: [
          'siteService',
          siteService => siteService.getWebsites()
            .then(websites => websites, () => [])
        ]
      }
    })
    .state('groups.list', {
      url: '',
      controller: 'GroupsListController',
      template: groupsListTemplate,
      data: {
        pageTitle: {
          de: 'Gruppen',
          en: 'Groups',
          es: 'Grupos',
          fr: 'Groupes'
        }
      }
    })
    .state('groups.group', {
      abstract: true,
      template: groupContainerTemplate,
      url: '/group/:groupId',
      controller: 'GroupContainerController'
    })
    .state('groups.group.overview', {
      url: '',
      template: groupOverviewTemplate,
      controller: 'GroupOverviewController',
      data: {
        pageTitle: {
          de: 'Gruppe',
          en: 'Group',
          es: 'Grupo',
          fr: 'Groupe'
        }
      }
    })
    .state('groups.group.task-triggers', {
      url: '/task-triggers',
      controller: 'GroupTaskTriggersController',
      template: groupTaskTriggersTemplate,
      data: {
        pageTitle: {
          de: 'Auslöser von Gruppenaufgaben',
          en: 'Group Task Trigger',
          es: 'Disparador de Tarea de Grupo',
          fr: 'Déclencheur de Tâche de Groupe'
        }
      }
    })
    .state('groups.group.notifications', {
      url: '/notifications',
      controller: 'NotificationsListController',
      template: groupNotificationsListTemplate,
      data: {
        pageTitle: {
          de: 'Benachrichtigungen | Gruppe',
          en: 'Notifications | Group',
          es: 'Notificaciones | Grupo',
          fr: 'Notifications | Groupe'
        }
      }
    })
    .state('groups.group.createnotification', {
      url: '/notifications/create',
      template: groupNotificationsTemplate,
      controller: 'NotificationEditorController',
      params: {
        notificationId: null,
        clone: false
      },
      data: {
        pageTitle: {
          de: 'Benachrichtigung Erstellen',
          en: 'Create Notification',
          es: 'Crear Notificación',
          fr: 'Créer Notification'
        }
      }
    })
    .state('groups.group.editnotification', {
      url: '/notifications/update/:notificationId',
      template: groupNotificationsTemplate,
      controller: 'NotificationEditorController',
      data: {
        pageTitle: {
          de: 'Benachrichtigung Bearbeiten',
          en: 'Edit Notification',
          es: 'Editar Notificación',
          fr: 'Modifier Notification'
        }
      }
    })
    .state('groups.group.manage', {
      url: '/manage',
      controller: 'GroupManageController',
      template: groupManageTemplate,
      data: {
        pageTitle: {
          de: 'Verwalten | Gruppe',
          en: 'Manage | Group',
          es: 'Gestionar | Grupo',
          fr: 'Gérer | Groupe'
        }
      }
    })
    .state('groups.group.task-triggers-create', {
      url: '/task-triggers-create',
      controller: 'GroupTaskTriggerController',
      template: groupTaskTriggerTemplate,
      data: {
        pageTitle: {
          de: 'Auslöser von Aufgaben Erstellen',
          en: 'Create Task Trigger',
          es: 'Crear Disparador de Tareas',
          fr: 'Créer Déclencheur de Tâches'
        }
      },
      resolve: {
        taskTrigger: [
          '$transition$',
          $transition$ => ({
            sections: [],
            task: {
              assignedGroup: $transition$.params().groupId,
              status: 1,
              priority: 2
            }
          })
        ]
      }
    })
    .state('groups.group.task-triggers-edit', {
      url: '/task-triggers/:triggerId',
      controller: 'GroupTaskTriggerController',
      template: groupTaskTriggerTemplate,
      data: {
        pageTitle: {
          de: 'Auslöser von Aufgaben Bearbeiten',
          en: 'Edit Task Trigger',
          es: 'Editar Disparador de Tarea',
          fr: 'Modifier Déclencheur de Tâche'
        }
      },
      resolve: {
        taskTrigger: [
          '$transition$',
          'taskTriggersService',
          ($transition$, taskTriggersService) => {
            const { triggerId } = $transition$.params();
            return taskTriggersService.getTrigger(triggerId);
          }
        ]
      }
    })
    .state('groups.create', {
      url: '/create',
      controller: 'GroupCreateController',
      template: groupCreateTemplate,
      data: {
        pageTitle: {
          de: 'Gruppe Erstellen',
          en: 'Create Group',
          es: 'Crear Grupo',
          fr: 'Créer Groupe'
        }
      }
    });
}

module.config([
  '$urlRouterProvider',
  '$stateProvider',
  routes
]);
